import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { fromEvent, retry, take, timer } from 'rxjs';
import {
  NETWORK_RETRY_DELAY,
  NETWORK_RETRY_MAX_TRY,
} from 'src/app/app.constants';

/* Requests that fail at the network level (status 0, e.g. ERR_CONNECTION_RESET
 * right after the device wakes from sleep) never reached the API, so GETs are
 * retried before the failure reaches the stores and triggers the global error
 * overlay. While the browser reports itself offline the retry waits for the
 * `online` event instead of polling on a timer. */
export const networkRetryInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'GET') {
    return next(request);
  }

  return next(request).pipe(
    retry({
      count: NETWORK_RETRY_MAX_TRY,
      delay: (error: HttpErrorResponse) => {
        if (error.status !== 0) {
          throw error;
        }

        return navigator.onLine
          ? timer(NETWORK_RETRY_DELAY)
          : fromEvent(window, 'online').pipe(take(1));
      },
    }),
  );
};
